import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom-v5-compat';
import { Dispatch, bindActionCreators } from 'redux';
import { Button, Divider } from 'src/components/atoms';
import { isRequiredFeatureEnabled } from 'src/components/auth';
import { StyledIconInButton } from 'src/components/foundations/foundations.styles';
import { useGetPublicFeaturesQuery } from 'src/graphql';
import useMediaQuery from 'src/hooks/useMediaQuery';
import * as Types from 'src/types';
import * as OpenReportingCreators from '../../../creators/OpenReporting.creators';
import {
  ButtonContainer,
  DividerContainer,
  DividerWrapper,
  SmallText,
} from './OPRLandingPage.styles';

interface Props {
  clearPublicReportData(): void;
  oprPage: string;
  handleOnLogin: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  organisation: string;
}

const OPRLandingPageButtons = (props: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isMobile = !useMediaQuery(`(min-width: 480px)`);

  const { data: publicFeatures } = useGetPublicFeaturesQuery({
    slug: props.organisation,
  });
  const isOPREnabled = isRequiredFeatureEnabled(
    (publicFeatures?.getPublicFeatures as Types.Feature[]) ?? [],
    Types.FeatureFlag.PUBLIC_REPORTING,
  );

  const handleCreateReport = () => {
    props.clearPublicReportData();
    navigate('relationship');
  };

  return (
    <ButtonContainer
      reverseOrder={props.oprPage === 'login'}
      isMobile={isMobile}
    >
      {isOPREnabled && (
        <>
          <Button
            variant={props.oprPage === 'login' ? 'secondary' : 'primary'}
            size="medium"
            data-testid="create-open-report"
            onClick={handleCreateReport}
            width="280px"
          >
            <>
              <StyledIconInButton
                size="medium"
                position="left"
                className="uil uil-plus"
              />
              {t('public.CreatePublicReport.createReport')}
            </>
          </Button>
          <DividerContainer>
            <DividerWrapper>
              <Divider variant="horizontal" />
            </DividerWrapper>
            <SmallText>{t('public.CreatePublicReport.or')}</SmallText>
            <DividerWrapper>
              <Divider variant="horizontal" />
            </DividerWrapper>
          </DividerContainer>
        </>
      )}
      <Button
        variant={
          !isOPREnabled || props.oprPage === 'login' ? 'primary' : 'secondary'
        }
        size="medium"
        data-testid="opr-login-button"
        onClick={props.handleOnLogin}
        width="280px"
        type="submit"
        disabled={props.disabled}
      >
        {t('public.CreatePublicReport.loginToOpr')}
      </Button>
    </ButtonContainer>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      ...OpenReportingCreators,
    },
    dispatch,
  );
export default connect(null, mapDispatchToProps)(OPRLandingPageButtons);
